const SET_SMART_SKIN_SCAN_CONTENT = 'SET_SMART_SKIN_SCAN_CONTENT';

export { SET_SMART_SKIN_SCAN_CONTENT };
